import { Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PageHeader = ({ title, onBack, children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        py: 2,
        borderBottom: "1px solid #E2E8F0",
        bgcolor: "#fff",
        position: "sticky",
        top: 0,
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          bgcolor: "#fff",
        }}
      >
        <Box
          onClick={onBack}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
            color: "#64748B",
            fontSize: 15,
            fontWeight: 500,
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#1E293B",
            },
          }}
        >
          <ArrowBackIcon sx={{ fontSize: 18 }} />
          <Typography sx={{ fontSize: 15, fontWeight: 500 }}>
            Back to Dashboard
          </Typography>
        </Box>
        <Box
          sx={{
            width: "1px",
            height: 24,
            bgcolor: "#E2E8F0",
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "#1E293B",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {children}
      </Box>
    </Box>
  );
};

export default PageHeader;
